export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return
  const feature =
    to.path === '/audit' || to.path.startsWith('/audit/')
      ? 'audits'
      : to.path === '/jobs' ||
          to.path.startsWith('/jobs/') ||
          to.path === '/process'
        ? 'intakes'
        : undefined
  if (
    !['/home', '/training', '/organizationSettings'].includes(to.path) &&
    !feature
  )
    return
  const orgStore = useOrgStore()
  if (!orgStore.selected.id) return
  // Refresh so changes made by an admin apply without signing in again.
  try {
    await orgStore.getOrg()
  } catch {
    return navigateTo('/access-restricted')
  }
  const { memberPermissions } = usePermissions()
  if (feature && !memberPermissions.value[feature].view)
    return navigateTo('/access-restricted')
})
